export default {
  CLEAR_EXPERIENCE_STATE: (state) => (state.experiencies = []),

  store: (state, payload) => {
    state.experiencies = [...state.experiencies, { ...payload }];
  },
  update: (state, payload) => {
    let _experiences = [...state.experiencies];
    const to_change = _experiences.filter((item) => item.id == payload.id)[0];
    const index = _experiences.indexOf(to_change);
    _experiences[index] = payload;

    state.experiencies = [..._experiences];
  },
  delete: (state, payload) => {
    let _experiences = [...state.experiencies];
    _experiences = [
      ..._experiences.slice(0, payload.index),
      ..._experiences.slice(payload.index + 1),
    ];

    state.experiencies = [..._experiences];
  },
  index: (state, payload) => {
    state.experiencies = [...payload];
  },

  ON_UNSKILLED: (state) => (state.unskilled = !state.unskilled),
};
